import { getAnchorPlugin } from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';

/* START OF COMPILED CODE */

import { DEFAULT_CURSOR_PATH } from '@/game/GameComponents/Utils/GameSpriteAssetsMap';
import UIBlocker from './UIBlocker';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class DefinitionExampleView
  extends Phaser.GameObjects.Container
{
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    this.visible = false;

    // uIBlocker_1
    const uIBlocker_1 = new UIBlocker(scene, 0, 0);
    this.add(uIBlocker_1);

    // _definitionExampleImage
    const _definitionExampleImage = scene.add.image(800, 512, '1x1sprite');
    _definitionExampleImage.scaleX = 0.25;
    _definitionExampleImage.scaleY = 0.25;
    this.add(_definitionExampleImage);

    // interactionButton
    const interactionButton = scene.add.nineslice(
      0,
      0,
      '1x1sprite',
      undefined,
      1600,
      1024,
      10,
      10,
      10,
      10,
    );
    interactionButton.setOrigin(0, 0);
    interactionButton.alpha = 0.00001;
    this.add(interactionButton);

    this._definitionExampleImage = _definitionExampleImage;
    this.interactionButton = interactionButton;

    /* START-USER-CTR-CODE */
    this.initialize();
    /* END-USER-CTR-CODE */
  }

  private _definitionExampleImage: Phaser.GameObjects.Image;
  private interactionButton: Phaser.GameObjects.NineSlice;

  /* START-USER-CODE */

  canCancelHelper: boolean = true;

  get definitionExampleImage() {
    return this._definitionExampleImage;
  }

  initialize() {
    // Interactivity.
    this.interactionButton.setInteractive({
      cursor: `${DEFAULT_CURSOR_PATH}, auto`,
    });
    this.interactionButton.on('pointerdown', () => this.handlePointerDown());

    // Responsiveness.
    const anchor = getAnchorPlugin(this.scene);
    anchor.add(this.definitionExampleImage, {
      centerX: '50%',
      centerY: '50%',
    });
  }

  showHelperVisual(texKey: string, duration: number = 2000) {
    if (this.scene.textures.get(texKey).key === '__MISSING') {
      console.error(`Texture ${texKey} not found`);
      // notifyZapierAboutError('error', {
      //   errorStatus: 'missing definition image',
      //   errorMessage: `missing definition image: ${texKey}`,
      //   url: window.location.href,
      //   timestamp: new Date().toISOString(),
      // });
      return;
    }
    this.canCancelHelper = false;
    this.scene.time.delayedCall(1000, () => {
      this.canCancelHelper = true;
    });

    this.definitionExampleImage.setTexture(texKey);
    this.setVisible(true);
    this.setAlpha(0);
    this.scene.tweens.killTweensOf(this);

    this.scene.tweens.add({
      targets: this,
      alpha: 1,
      duration,
      ease: 'Power2',
      yoyo: true,
      onComplete: () => {
        this.setVisible(false);
      },
    });
  }

  handlePointerDown() {
    if (this.canCancelHelper) {
      this.cancelExample();
    }
  }

  cancelExample() {
    this.setVisible(false);
    this.scene.tweens.killTweensOf(this);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
